import "@/App.css";
import { BrowserRouter, Routes, Route, Navigate } from "react-router-dom";
import { Toaster } from "@/components/ui/sonner";
import { AuthProvider, useAuth } from "@/context/AuthContext";
import DashboardLayout from "@/layouts/DashboardLayout";
import Login from "@/pages/Login";
import Register from "@/pages/Register";
import ForgotPassword from "@/pages/ForgotPassword";
import ResetPassword from "@/pages/ResetPassword";
import Onboarding from "@/pages/Onboarding";
import Dashboard from "@/pages/Dashboard";
import CalendarPage from "@/pages/CalendarPage";
import Appointments from "@/pages/Appointments";
import Services from "@/pages/Services";
import Employees from "@/pages/Employees";
import Availability from "@/pages/Availability";
import Exceptions from "@/pages/Exceptions";
import Customers from "@/pages/Customers";
import Integrations from "@/pages/Integrations";
import Settings from "@/pages/Settings";
import AdminDashboard from "@/pages/AdminDashboard";
import PublicQuote from "@/pages/PublicQuote";
import PublicBooking from "@/pages/PublicBooking";
import Quotes from "@/pages/Quotes";

export function FullLoader() {
  return (
    <div className="min-h-screen flex items-center justify-center bg-slate-50" data-testid="app-loader">
      <div className="h-8 w-8 animate-spin rounded-full border-2 border-slate-300 border-t-blue-600" />
    </div>
  );
}

function Protected({ children }) {
  const { user } = useAuth();
  if (user === null) return <FullLoader />;
  if (!user) return <Navigate to="/login" replace />;
  return children;
}

function TenantProtected({ children }) {
  const { user, tenant } = useAuth();
  if (user === null || (user && tenant === undefined)) return <FullLoader />;
  if (!user) return <Navigate to="/login" replace />;
  if (tenant === null) return <Navigate to="/onboarding" replace />;
  return children;
}

function App() {
  return (
    <AuthProvider>
      <BrowserRouter>
        <Routes>
          <Route path="/login" element={<Login />} />
          <Route path="/register" element={<Register />} />
          <Route path="/forgot-password" element={<ForgotPassword />} />
          <Route path="/reset-password" element={<ResetPassword />} />

          {/* Pages publiques accessibles aux clients */}
          <Route path="/quote/:slug" element={<PublicQuote />} />
          <Route path="/book/:slug" element={<PublicBooking />} />
          <Route path="/b/:slug" element={<PublicBooking />} />

          {/* Routes protégées */}
          <Route path="/onboarding" element={<Protected><Onboarding /></Protected>} />
          <Route path="/admin" element={<Protected><AdminDashboard /></Protected>} />
          
          <Route path="/" element={<TenantProtected><DashboardLayout /></TenantProtected>}>
            <Route index element={<Dashboard />} />
            <Route path="calendar" element={<CalendarPage />} />
            <Route path="appointments" element={<Appointments />} />
            <Route path="services" element={<Services />} />
            <Route path="employees" element={<Employees />} />
            <Route path="availability" element={<Availability />} />
            <Route path="exceptions" element={<Exceptions />} />
            <Route path="customers" element={<Customers />} />
            <Route path="integrations" element={<Integrations />} />
            <Route path="quotes" element={<Quotes />} />
            <Route path="settings" element={<Settings />} />
          </Route>

          {/* Redirection globale */}
          <Route path="*" element={<Navigate to="/" replace />} />
        </Routes>
      </BrowserRouter>
      <Toaster position="top-center" richColors />
    </AuthProvider>
  );
}

export default App;